import {useCallback, useEffect, useState} from 'react';
import {apiFetch} from '../api';

export const VIEW_DEFAULTS = {
    all: {sortKey: 'created', sortDirection: 'desc'},
    starred: {sortKey: 'created', sortDirection: 'desc'},
    templates: {sortKey: 'created', sortDirection: 'desc'},
    scheduled: {sortKey: 'due', sortDirection: 'asc'},
    inbox: {sortKey: 'manual', sortDirection: 'desc'},
};

export default function useViewPreferences({onError}) {
    const [preferences, setPreferences] = useState({});

    useEffect(() => {
        const controller = new AbortController();
        apiFetch('/users/me/view-preferences', {signal: controller.signal})
            .then(res => res.json())
            .then(list => {
                const next = {};
                for (const pref of list || []) {
                    next[pref.view] = {sortKey: pref.sortKey, sortDirection: pref.sortDirection};
                }
                setPreferences(next);
            })
            .catch(err => {
                if (err.name !== 'AbortError' && onError) onError(err);
            });
        return () => controller.abort();
    }, [onError]);

    const getPreference = useCallback(
        view => {
            return preferences[view] || VIEW_DEFAULTS[view] || {sortKey: 'manual', sortDirection: 'desc'};
        },
        [preferences],
    );

    const setPreference = useCallback(
        (view, sortKey, sortDirection) => {
            setPreferences(prev => ({...prev, [view]: {sortKey, sortDirection}}));
            apiFetch(`/users/me/view-preferences/${view}`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({sortKey, sortDirection}),
            }).catch(err => {
                if (onError) onError(err);
            });
        },
        [onError],
    );

    return {preferences, getPreference, setPreference};
}
